import { useEffect, useState } from 'react'
import { supabase } from './supabaseClient'
import TaskForm from './components/TaskForm'
import TaskList from './components/TaskList'
import './App.css'

function App() {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)

  // Fetch tasks
  const fetchTasks = async () => {
    setLoading(true)
    const { data, error } = await supabase
      .from('tasks')
      .select('*')
      .order('completed', { ascending: true })
      .order('created_at', { ascending: true })
    
    if (!error) setTasks(data)
    setLoading(false)
  }

  // Add task
  const addTask = async (description) => {
    const { error } = await supabase.from('tasks').insert([{ description }])
    if (!error) fetchTasks()
  }

  // Toggle task completion
  const toggleTask = async (id, currentStatus) => {
    const { error } = await supabase
      .from('tasks')
      .update({ completed: !currentStatus })
      .eq('id', id)
    if (!error) fetchTasks()
  }

  // Delete task
  const deleteTask = async (id) => {
    const { error } = await supabase.from('tasks').delete().eq('id', id)
    if (!error) fetchTasks()
  }

  useEffect(() => {
    fetchTasks()
  }, [])

  const completedTasks = tasks.filter(task => task.completed).length
  const totalTasks = tasks.length

  return (
    <div className="app-container">
      <div className="app-header">
        <h1 className="app-title">✓ Task Tracker</h1>
        <div className="task-stats">
          <span className="stats-badge">
            {completedTasks}/{totalTasks} completed
          </span>
        </div>
      </div>
      
      <TaskForm addTask={addTask} />
      
      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading tasks...</p>
        </div>
      ) : (
        <TaskList tasks={tasks} toggleTask={toggleTask} deleteTask={deleteTask} />
      )}
      
      {!loading && tasks.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">📝</div>
          <h3>No tasks yet</h3>
          <p>Add your first task above to get started!</p>
        </div>
      )}
    </div>
  )
}

export default App